module.exports = __webpack_public_path__ + "static/media/upload-visuals-old.723420f0.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/upload-visuals-old.jpg
// module id = 96
// module chunks = 3